module.exports = __webpack_public_path__ + "static/media/bg-home.022be4c8.jpg";